<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.MyPurse}}</p>
    </div>

    <div class="wallet-box">
      <div class="l-box">
        <div class="wallet">
          <p class="title">{{words.AccountBalance}}</p>
          <p class="text" @click="$lfy.Jump.open('/wallet-log')">{{words.IncomeRecord}}</p>
          <p class="money">{{user.money}}</p>
        </div>
        <div class="Recharge">
          <div class="item-box">
            <div
              class="item"
              v-for="(item,key) in moneyData"
              :class="{select:item.selectStatus}"
              @click="ItemChange(key)"
              :key="key"
            >
              {{item.money || ''}}{{item.money ? item.com : ''}}
              <input
                type="number"
                class="input"
                v-if="!item.money"
                :placeholder="words.Other"
                :class="{select:item.selectStatus}"
                @input="handleInput"
                v-model="RechargeMoney"
              />
            </div>
          </div>
          <p
            class="btn"
            @click="pay"
            :class="{payStatus:!payStatus}"
          >{{!payStatus?words.Pay:'支付完成'}}</p>
        </div>
      </div>
      <div class="r-box">
        <div class="title">{{words.Receiver}}</div>
        <div class="img-box">
          <div class="img" v-show="!payStatus">
            <img :src="peyStatusImageNot" class="peyStatusImageNot" alt />
          </div>
          <div class="qr-box" v-show="payStatus">
            <div class="qrcode-box">
              <p class="title">{{words.ScanCodeRecharge}}{{RechargeMoney1}}.00{{words.yuan}}</p>
              <!-- <img :src="qrcode" class="qrcode" alt> -->
              <div class="qrcode" id="qrcode"></div>
              <div style="margin-left: 15px;font-size: 12px;margin-top: 15px;">请使用支付宝扫码充值</div>
            </div>
            <!-- <div class="scan-box">
              <img :src="peyStatusImage" class="peyStatusImage" alt />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import QRCode from "qrcodejs2";
import config from "../../config";
export default {
  components: {},
  data() {
    return {
      moneyData: [
        {
          money: 100,
          com: "元",
          selectStatus: true,
          is_mnum: true
        },
        {
          money: 50,
          com: "元",
          selectStatus: false,
          is_mnum: true
        },
        {
          money: 30,
          com: "元",
          selectStatus: false,
          is_mnum: true
        },
        {
          money: 20,
          com: "元",
          selectStatus: false,
          is_mnum: true
        },
        {
          money: 10,
          com: "元",
          selectStatus: false,
          is_mnum: true
        },
        {
          money: "",
          com: "其它金额",
          selectStatus: false,
          is_mnum: false
        }
      ],
      RechargeMoney: "",
      RechargeMoney1: 100,
      payStatus: false,
      peyStatusImageNot: require("../../assets/recharge.png"),
      peyStatusImage: require("../../assets/mobile.png"),
      qrcode: require("../../assets/1558079779.png")
    };
  },
  mounted() {
    this.moneyData.map(item => {
      if (item.is_mnum) item.com = this.words.yuan;
      else item.com = this.words.Other;
    });
    this.GetUserInfo().then(res => {
      this.setUser(res.data);
    });
  },
  methods: {
    ...mapActions(["setUser", "getBannber", "GetUserInfo", "setUser"]),
    ItemChange(key) {
      if (this.payStatus) this.payStatus = false;
      if (key < 5) this.RechargeMoney = "";
      this.moneyData.map((item, index) => {
        if (index === key) {
          item.selectStatus = true;
          this.RechargeMoney1 = item.money;
        } else item.selectStatus = false;
      });
    },
    handleInput(e) {
      this.RechargeMoney = e.target.value.replace(/[^\d]/g, "");
    },
    pay() {
      if (this.payStatus) {
        this.payStatus = false;
        this.GetUserInfo().then(res => {
          res.data.token = this.user.token;
          this.setUser(res.data);
        });
        return false;
      }
      if (parseInt(this.RechargeMoney) < 5) {
        this.$Message.error("最低充值5元");
        return false;
      }
      if (parseInt(this.RechargeMoney) > 1000) {
        this.$Message.error("最多充值1000元");
        return false;
      }
      this.payStatus = true;
      console.log(this.RechargeMoney, parseInt(this.RechargeMoney1));
      if (!this.RechargeMoney1)
        this.RechargeMoney1 = parseInt(this.RechargeMoney);

      this.qrccode();
    },
    qrccode() {
      document.getElementById("qrcode").innerHTML = "";

      let qrcode = new QRCode("qrcode", {
        width: 150,
        height: 150,
        text: `${config.payQrcodeUrl}?uid=${this.user.id}&money=${this.RechargeMoney1}`, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff"
      });
    }
  },
  computed: {
    ...mapGetters({
      words: "words",
      user: "user"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>